<template>
    <div class="left-panel">
        <div class="panel-section">
            <div class="section-title">
                <div class="title-main">批注管理{{ isPrevDrawing ? '（旧版）' : '（新版）' }}</div>
                <div class="title-sub">共 {{ annotations.length }} 条批注</div>
            </div>

            <!-- 批注列表 -->
            <div class="annotation-list">
                <div
                    v-for="item in annotations"
                    :key="item.id"
                    class="annotation-item"
                    :class="{ 'item-selected': item.id === activeAnnotation }"
                    @click="handleItemClick(item)"
                >
                    <div class="item-header">
                        <div class="item-left">
                            <span class="status-dot" :class="item.statusClass" v-show="editingId !== item.id"></span>
                            <input v-if="editingId === item.id" class="edit-title-input" v-model="editCache.title" />
                            <span v-else class="item-title">{{ item.title }}</span>
                        </div>
                        <span class="status-tag" :class="item.statusTagClass" v-show="editingId !== item.id">{{ item.statusText }}</span>
                    </div>
                    <div v-if="editingId === item.id" class="item-content">
                        <textarea class="edit-content-textarea" v-model="editCache.content"></textarea>
                    </div>
                    <div v-else class="item-content">
                        {{ item.content }}
                        <div class="create-info">
                            <span class="create-name">{{ item.createName }}</span>
                            <span class="create-at">{{ formatCreateAt(item.createAt) }}</span>
                        </div>
                    </div>
                    <div class="item-footer">
<!--                        <span class="creator">{{ item.creator }}</span>-->
                        <div class="actions">
                            <template v-if="!viewMode && !isPrevDrawing">
                                <span v-if="editingId === item.id" class="action-btn save-edit-btn" @click.stop="handleEditSave(item)">保存</span>
                                <span v-if="editingId === item.id" class="action-btn cancel-edit-btn" @click.stop="handleEditCancel">取消</span>
                                <span v-else-if="!item.replyContent && item.status !== 'End'" class="action-btn edit-btn" @click.stop="handleEdit(item)">编辑</span>
                                <span v-if="!item.replyContent && item.status !== 'End'" class="action-btn delete-btn" @click.stop="handleDelete(item)">删除</span>
                            </template>
                            <template v-else>
                                <span v-if="replyingId === item.id" class="action-btn save-edit-btn" @click.stop="handleReplySave(item)">保存回复</span>
                                <span v-if="replyingId === item.id" class="action-btn cancel-edit-btn" @click.stop="handleReplyCancel">取消</span>
                                <span v-else-if="item.replyContent && item.status !== 'End'" class="action-btn edit-btn" @click.stop="handleReply(item)">编辑</span>
                                <span v-else-if="!item.replyContent && item.status !== 'End'" class="action-btn reply-btn" @click.stop="handleReply(item)">回复</span>
                            </template>
                        </div>
                    </div>
                    <div v-if="replyingId === item.id" class="reply-input-area">
                        <textarea class="reply-textarea" v-model="replyCache" placeholder="请输入回复内容" @input="onReplyInput(item)"></textarea>
                    </div>
                    <div v-if="item.replyContent" class="pending-reply">
                        <span class="reply-label">回复：</span>
                        <span class="reply-text">{{ item.replyContent }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部按钮栏 -->
        <div class="button-bar">
            <button class="btn save-btn" @click="handleSave">保存</button>
            <button class="btn cancel-btn" @click="handleSaveAndClose">保存并关闭</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "annotationLeftPanel",
    props: {
        annotationList: { type: Array, default: () => [] },
        activeAnnotation: { type: [String, Number], default: "" },
        viewMode: { type: Boolean, default: false },
        pendingReplies: { type: Array, default: () => [] },
        activeAnnoReplyContent: { type: String, default: '' },
        userId: { type: String, default: "" },
        isPrevDrawing: { type: Boolean, default: false },
    },
    data() {
        return {
            editingId: '',
            editCache: { title: '', content: '' },
            replyingId: '',
            replyCache: '',
        };
    },
    computed: {
        annotations() {
            console.log("this.annotationList::",this.annotationList)
            return this.annotationList.map(item => {
                const reply = this.pendingReplies.find(r => r.id === item.id);
                const hasPendingReply = !!reply;
                const apiReplyContent = item.replyContent || '';
                const hasApiReply = !!apiReplyContent;
                const isEndStatus = item.status === 'End';
                let statusText = '待处理';
                let statusClass = 'status-red';
                let statusTagClass = 'tag-red';
                const displayReplyContent = hasPendingReply ? reply.replyContent : apiReplyContent;
                if (hasPendingReply || hasApiReply || isEndStatus) {
                    statusText = '已回复';
                    statusClass = 'status-green';
                    statusTagClass = 'tag-green';
                }

                console.log("item:::",item)
                return {
                    id: item.id,
                    title: item.title || '',
                    content: item.content || '',
                    creator: item.creator || '',
                    createBy: item.createBy || '',
                    createAt: item.createAt || '',
                    createName: item.createName || item.author || '',
                    isCreator: item.createBy === this.userId,
                    status: item.status || '',
                    statusText,
                    statusClass,
                    statusTagClass,
                    replyContent: displayReplyContent,
                };
            });
        },
    },
    watch: {
        activeAnnoReplyContent(val) {
            if (val && this.activeAnnotation) {
                const item = this.annotations.find(a => a.id === this.activeAnnotation);
                if (item && item.status !== 'End') {
                    this.replyingId = this.activeAnnotation;
                    this.replyCache = val;
                    this.$emit('consume-reply-content');
                }
            }
        },
    },
    methods: {
        formatCreateAt(val) {
            if (!val) return '';
            const d = new Date(val);
            if (isNaN(d.getTime())) return val;
            const pad = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        handleItemClick(item) {
            if (this.editingId) return;
            this.$emit("select", item.id);
        },
        handleEdit(item) {
            this.editingId = item.id;
            this.editCache = { title: item.title, content: item.content };
        },
        handleEditSave(item) {
            this.$emit("update-annotation", { id: item.id, title: this.editCache.title, content: this.editCache.content });
            this.editingId = '';
        },
        handleEditCancel() {
            this.editingId = '';
        },
        handleDelete(item) {
            this.$emit("delete", item.id);
        },
        handleSave() {
            this.$emit("save");
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleSaveAndClose() {
            this.$emit("save-and-close");
        },
        handleReply(item) {
            this.replyingId = item.id;
            this.replyCache = item.replyContent || '';
        },
        handleReplySave(item) {
            if (!this.replyCache.trim()) {
                this.$message.warning('请输入回复内容');
                return;
            }
            this.$emit('reply', { id: item.id, content: this.replyCache });
            this.replyingId = '';
            this.replyCache = '';
        },
        handleReplyCancel() {
            this.replyingId = '';
            this.replyCache = '';
        },
        onReplyInput(item) {
            this.$emit('reply', { id: item.id, content: this.replyCache });
        }
    }
};
</script>

<style lang="less" scoped>
.left-panel {
    width: 280px;
    min-width: 280px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-left: 1px solid #e8e8e8;
}
.panel-section {
    padding: 16px;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
}
.section-title {
    margin-bottom: 10px;
    .title-main {
        font-size: 18px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 8px;
    }
    .title-sub {
        font-size: 16px;
        color: #666666;
    }
}

.annotation-list {
        .annotation-item {
            background: #fff;
            border: 1px solid #e8e8e8;
            border-radius: 12px;
            padding: 10px 15px;
            margin-bottom: 16px;
            cursor: pointer;
            transition: border-color 0.2s;
            &:hover { border-color: #1890ff; }
            &.item-selected {
                border-color: #1890ff;
                box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
            }

        .item-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;

            .item-left {
                display: flex;
                align-items: center;
                .status-dot {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    margin-right: 12px;
                    &.status-red { background: #ff4d4f; }
                    &.status-yellow { background: #faad14; }
                    &.status-green { background: #52c41a; }
                    &.status-blue { background: #1890ff; }
                }
                .item-title {
                    font-size: 16px;
                    font-weight: 500;
                    color: #1a1a1a;
                }
            }
            .status-tag {
                font-size: 14px;
                padding: 4px 12px;
                border-radius: 12px;
                &.tag-red { background: #fff2f0; color: #ff4d4f; }
                &.tag-green { background: #f6ffed; color: #52c41a; }
                &.tag-blue { background: #e6f7ff; color: #1890ff; }
            }
        }

        .item-content {
            font-size: 12px;
            color: #666;
            line-height: 1.6;
            margin-bottom: 10px;
        }
        .create-info {
            display: flex;
            justify-content: space-between;
            margin-top: 4px;
        }
        .create-name {
            color: #999;
        }
        .create-by {
            color: #bbb;
            font-size: 11px;
        }
        .create-at {
            color: #bbb;
            font-size: 11px;
        }
        .edit-title-input {
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 2px 6px;
            font-size: 14px;
            font-weight: 500;
            width: 100%;
            outline: none;
            &:focus { border-color: #1890ff; }
        }
        .edit-content-textarea {
            width: 100%;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 4px 6px;
            font-size: 12px;
            resize: vertical;
            min-height: 50px;
            outline: none;
            box-sizing: border-box;
            &:focus { border-color: #1890ff; }
        }

        .item-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .creator {
                font-size: 12px;
                color: #999;
            }
            .actions {
                display: flex;
                gap: 16px;
            .action-btn {
                font-size: 12px;
                cursor: pointer;
                &.edit-btn { color: #1890ff; }
                &.delete-btn { color: #ff4d4f; }
                &.save-edit-btn { color: #52c41a; font-weight: 600; }
                &.cancel-edit-btn { color: #999; }
                &.reply-btn { color: #1890ff; }
            }
            }
        }
    }
}

.reply-input-area {
    padding: 8px 0 4px;
    .reply-textarea {
        width: 100%;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        padding: 6px 8px;
        font-size: 12px;
        resize: vertical;
        min-height: 50px;
        outline: none;
        box-sizing: border-box;
        &:focus { border-color: #1890ff; }
    }
}

.pending-reply {
    margin-top: 8px;
    padding: 6px 8px;
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1.5;
    .reply-label {
        color: #52c41a;
        font-weight: 500;
    }
    .reply-text {
        color: #333;
    }
}

/* 底部按钮栏 */
.button-bar {
    display: flex;
    gap: 12px;
    padding: 16px;
    border-top: 1px solid #e8e8e8;
    background: #fff;

    .btn {
        flex: 1;
        height: 35px;
        border: none;
        border-radius: 2px;
        font-size: 16px;
        cursor: pointer;
        &.save-btn {
            background: #1890ff;
            color: #fff;
        }
        &.cancel-btn {
            background: #e5e7eb;
            color: #666;
        }
    }
}
</style>